export const urls = {
  setUserAuth: "/splx_setUserAuth",
};
